export { default } from './EzWorkingHours.vue';
